import React, { useState } from 'react';
import './Contacto.css';

export default function ContactoPage() {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', asunto: '', mensaje: '' });
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Construir mensaje de WhatsApp
    const texto = encodeURIComponent(
      `*Contacto VuelveACasa RD*\n\n` +
      `*Nombre:* ${form.nombre}\n` +
      `*Email:* ${form.email || 'No indicado'}\n` +
      `*Teléfono:* ${form.telefono || 'No indicado'}\n` +
      `*Asunto:* ${form.asunto}\n\n` +
      `*Mensaje:*\n${form.mensaje}`
    );
    window.open(`https://wa.me/18092668206?text=${texto}`, '_blank');
    setEnviado(true);
    setTimeout(() => setEnviado(false), 5000);
    setForm({ nombre: '', email: '', telefono: '', asunto: '', mensaje: '' });
  };

  return (
    <div className="ct-page">

      {/* Hero */}
      <section className="ct-hero">
        <div className="ct-hero-inner">
          <div className="ct-hero-badge">💬 Estamos Aquí Para Ti</div>
          <h1>Contáct<span className="ct-accent">anos</span></h1>
          <p className="ct-hero-sub">
            Si tienes un caso que reportar, información sobre una persona desaparecida,
            o quieres colaborar con nuestra causa, estamos disponibles para atenderte.
          </p>
        </div>
      </section>

      <div className="ct-content">

        {/* Info de contacto */}
        <div className="ct-info-col">

          <div className="ct-info-box">
            <h2>Información de <span className="ct-accent">Contacto</span></h2>

            <a
              href="https://wa.me/18092668206"
              target="_blank"
              rel="noopener noreferrer"
              className="ct-contact-item ct-contact-whatsapp"
            >
              <div className="ct-contact-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div className="ct-contact-text">
                <span className="ct-contact-label">WhatsApp (Principal)</span>
                <span className="ct-contact-val">+1 (809) 266-8206</span>
              </div>
            </a>

            <a
              href="https://www.facebook.com/VuelveACasaRD"
              target="_blank"
              rel="noopener noreferrer"
              className="ct-contact-item"
            >
              <div className="ct-contact-icon ct-icon-fb">
                <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </div>
              <div className="ct-contact-text">
                <span className="ct-contact-label">Facebook</span>
                <span className="ct-contact-val">VuelveACasa RD</span>
              </div>
            </a>

            <a
              href="https://www.instagram.com/vuelveacasard"
              target="_blank"
              rel="noopener noreferrer"
              className="ct-contact-item"
            >
              <div className="ct-contact-icon ct-icon-ig">
                <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </div>
              <div className="ct-contact-text">
                <span className="ct-contact-label">Instagram</span>
                <span className="ct-contact-val">@vuelveacasard</span>
              </div>
            </a>

            <div className="ct-contact-item">
              <div className="ct-contact-icon ct-icon-loc">🌐</div>
              <div className="ct-contact-text">
                <span className="ct-contact-label">Sitio Web</span>
                <span className="ct-contact-val">vuelveacasard.org</span>
              </div>
            </div>
          </div>

          {/* Horario */}
          <div className="ct-horario-box">
            <h3>⏰ Disponibilidad</h3>
            <div className="ct-horario-item">
              <span>Lunes – Viernes</span>
              <span className="ct-hor-val">8:00 AM – 10:00 PM</span>
            </div>
            <div className="ct-horario-item">
              <span>Sábados – Domingos</span>
              <span className="ct-hor-val">9:00 AM – 8:00 PM</span>
            </div>
            <p className="ct-horario-note">
              🚨 Para casos <strong>urgentes</strong> respondemos las 24 horas por WhatsApp.
            </p>
          </div>

          {/* Urgente box */}
          <div className="ct-urgente-box">
            <div className="ct-urgente-icon">🚨</div>
            <h3>¿Es un caso urgente?</h3>
            <p>Si la persona desapareció en las últimas 24-48 horas, contáctanos <strong>inmediatamente</strong> por WhatsApp.</p>
            <a
              href="https://wa.me/18092668206?text=URGENTE%3A%20Necesito%20reportar%20una%20persona%20desaparecida"
              target="_blank"
              rel="noopener noreferrer"
              className="ct-urgente-btn"
            >
              📱 WhatsApp Urgente
            </a>
          </div>

        </div>

        {/* Formulario */}
        <div className="ct-form-col">
          <div className="ct-form-box">
            <h2>Envíanos un <span className="ct-accent">Mensaje</span></h2>
            <p className="ct-form-sub">Completa el formulario y te contactaremos por WhatsApp.</p>

            {enviado && (
              <div className="ct-success-msg">
                ✅ ¡Mensaje enviado! Te redirigimos a WhatsApp para confirmar.
              </div>
            )}

            <form onSubmit={handleSubmit} className="ct-form">
              <div className="ct-form-row">
                <div className="ct-field">
                  <label>Nombre Completo *</label>
                  <input
                    type="text"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    placeholder="Tu nombre"
                    required
                  />
                </div>
                <div className="ct-field">
                  <label>Teléfono</label>
                  <input
                    type="tel"
                    name="telefono"
                    value={form.telefono}
                    onChange={handleChange}
                    placeholder="809-000-0000"
                  />
                </div>
              </div>

              <div className="ct-field">
                <label>Correo Electrónico</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="tu@correo.com"
                />
              </div>

              <div className="ct-field">
                <label>Asunto *</label>
                <select name="asunto" value={form.asunto} onChange={handleChange} required>
                  <option value="">Selecciona un asunto...</option>
                  <option value="Reportar caso desaparecido">Reportar caso desaparecido</option>
                  <option value="Información sobre caso publicado">Información sobre caso publicado</option>
                  <option value="Caso encontrado - actualizar">Caso encontrado - actualizar</option>
                  <option value="Colaborar como voluntario">Colaborar como voluntario</option>
                  <option value="Alianza o patrocinio">Alianza o patrocinio</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              <div className="ct-field">
                <label>Mensaje *</label>
                <textarea
                  name="mensaje"
                  value={form.mensaje}
                  onChange={handleChange}
                  placeholder="Escribe tu mensaje aquí. Si reportas un caso, incluye nombre, edad, lugar y fecha de desaparición..."
                  rows={5}
                  required
                />
              </div>

              <button type="submit" className="ct-submit-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Enviar por WhatsApp
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
}
